import {observer} from "mobx-react";
import SelectSearchMain from "@dropDesk/presentation/components/inputs/select_search_main";
import {useInjection} from "inversify-react";
import {AppController} from "@dropDesk/presentation/app/app.controller";
import {
    Body,
    Container,
    Footer,
    PaddingFilters
} from "./styled";
import FilterButton from "@dropDesk/presentation/components/filters/filter_button";
import ButtonNew from "@dropDesk/presentation/components/buttons/button_new";
import React, {useEffect, useRef, useState} from "react";
import {UserEntity} from "@dropDesk/domain/entities/user/user.entity";
import {evaluationValueMap} from "@dropDesk/domain/entities/ticket/evaluation/ticket_evaluation_maps";
import {evaluationEnum} from "@dropDesk/domain/entities/ticket/evaluation/ticket_evaluation_enum";
import {useBetween} from "use-between";
import {
    useModalsReportTicketEvaluations
} from "@dropDesk/presentation/pages/ticket/evaluation/ui/search/modals/handle_change_visible";
import {ICONS_DROPDESK} from "@dropDesk/storage/icons/icons.d";
import InputWithBorder from "@dropDesk/presentation/components/inputs/input_with_border";

const Filters = observer(
    ({
         contact,
         attendant,
         setFilterContact,
         setFilterAttendant,
         loading,
         onSearch,
         searchEvaluationValue,
         setSearchEvaluationValue
     }: {
        setFilterContact: (contact: UserEntity | null, withList?: boolean) => void,
        setFilterAttendant: (attendant: UserEntity | null, withList?: boolean) => void,
        setSearchEvaluationValue: (value: number | null, withList?: boolean) => void,
        contact: UserEntity | null,
        attendant: UserEntity | null,
        searchEvaluationValue: number | null,
        onSearch: (searchParam?: string) => void,
        loading: boolean,
    }) => {

        const [visible, setVisible] = useState<boolean>(false);
        const [initialized, setInitialized] = useState<boolean>(false);
        const [zIndex, setZIndex] = useState<number>(0);
        const appController = useInjection(AppController);
        const colors = appController.theme.colorScheme;
        const timeoutRef = useRef<number | undefined>(undefined);


        const handleClickChange = (open: boolean, timeout = 0) => {
            if (open) {
                if (timeoutRef.current) {
                    clearTimeout(timeoutRef.current);
                }
                setZIndex(1300);
            } else {
                timeoutRef.current = window.setTimeout(() => {
                    setZIndex(0);
                }, timeout);
            }
            setVisible(open);
        };

        const {
            setVisibleModalSearchAttendant,
            setVisibleModalSearchContacts,
            visibleModalSearchAttendant,
            visibleModalSearchContacts
        } = useBetween(useModalsReportTicketEvaluations);

        useEffect(() => {
            setInitialized(true);
            if ((visibleModalSearchContacts || visibleModalSearchAttendant) && initialized) {
                handleClickChange(false);
            } else if (initialized) {
                handleClickChange(true);
            }

        }, [visibleModalSearchAttendant, visibleModalSearchContacts]);

        return (
            <FilterButton
                hasFilter={(!!contact || !!attendant || !!searchEvaluationValue)}
                loading={loading}
                open={visible}
                onOpenChange={handleClickChange}
                zIndex={zIndex}
                content={
                    <Container border={colors.border}>
                        <Body>
                            <PaddingFilters style={{maxWidth: 250}}>
                                <InputWithBorder
                                    name='user'
                                    size={37}
                                    onClick={() => {
                                        setVisibleModalSearchContacts(true);
                                    }}
                                    readOnly={true}
                                    disabled={loading}
                                    placeHolder={"Selecione o contato"}
                                    nameIconRight={ICONS_DROPDESK.downArrow}
                                    sizeRightIcons={14}
                                    marginRightRightIcons={10}
                                    label={"Contato"}
                                    value={contact?.name ?? ''}
                                    useButtonRight={true}
                                    labelButtonRight={"Remover filtro"}
                                    onClickButtonRight={() => {
                                        setFilterContact(null);
                                    }}
                                    onChange={() => {
                                    }}
                                />
                            </PaddingFilters>
                            <PaddingFilters style={{maxWidth: 250}}>

                                <InputWithBorder
                                    name='user'
                                    size={37}
                                    onClick={() => setVisibleModalSearchAttendant(true)}
                                    readOnly={true}
                                    disabled={loading}
                                    placeHolder={"Selecione o atendente"}
                                    nameIconRight={ICONS_DROPDESK.downArrow}
                                    sizeRightIcons={14}
                                    marginRightRightIcons={10}
                                    label={"Atendente"}
                                    value={attendant?.name ?? ''}
                                    useButtonRight={true}
                                    labelButtonRight={"Remover filtro"}
                                    onClickButtonRight={() => {
                                        setFilterAttendant(null)
                                    }}
                                    onChange={() => {
                                    }}
                                />
                            </PaddingFilters>

                            <PaddingFilters>
                                <SelectSearchMain<evaluationEnum>
                                    size={40}
                                    width={250}
                                    useRemoveFilter={!!searchEvaluationValue}
                                    label={'Filtrar por avaliação'}
                                    placeHolder={"Selecione o valor"}
                                    options={evaluationValueMap}
                                    removeSort={true}
                                    onClickRemoveFilter={() => {
                                        setSearchEvaluationValue(null);
                                    }}
                                    onChange={(value) => {
                                        setSearchEvaluationValue(value);
                                    }}
                                    value={searchEvaluationValue ? searchEvaluationValue : null}
                                />
                            </PaddingFilters>

                        </Body>
                        <Footer>
                            <ButtonNew
                                label={'limpar filtros'}
                                onClick={() => {
                                    setFilterAttendant(null, false);
                                    setFilterContact(null, false);
                                    setSearchEvaluationValue(null, false);
                                    onSearch();
                                    setVisible(false);
                                }}
                                useIcon={false}
                                sizeLeftIcon={15}
                                disabled={loading}
                                radius={25}
                            />
                        </Footer>
                    </Container>
                }/>

        )
    })
export default Filters;
